import log from 'loglevel';

const de_DE = require('./locales/de_DE/messages.js');
const en_US = require('./locales/en_US/messages.js');

/**
 * Load up environment variables.
 */
let logLevel = 'error';
// let aUrl = 'https://api.connect.autodesk.com/v1/';
// let aKey = process.env.REACT_APP_GOOGLE_API_KEY_PRD;

/**
 * example if using an app; storybook always builds as development
 * // if (process.env.REACT_APP_BUILD === 'dev') {
 * Need to figure out how to switch for environments, if necessary.
 */
if (process.env.NODE_ENV === 'development') {
  logLevel = 'debug';
  // aUrl = 'https://api-dev.connect.autodesk.com/v1/';
  // aKey = process.env.REACT_APP_GOOGLE_API_KEY_DEV;
}

// export const apiUrl = aUrl;
// export const apiKey = aKey;

log.setLevel(logLevel);
log.debug('Log Level', log.getLevel());
log.debug('Data', process.env.REACT_APP_DATA_VERSION);

// Examples of log levels
// log.trace('trace');
// log.debug('debug');
// log.info('info');
// log.warn('warn default');
// log.error('error')

export const href = window.location.href;

/**
 * Returns domain of environment. Switches ports for testing.
 *
 * @returns { string } domain name
 */
function getDomain() {
  return window.location.protocol + '//' + window.location.hostname + ':3000';
}

export const domain = getDomain();

export const tiers = ['dev', 'stg', 'prd'];

export const catalogs = {
  de_DE,
  en_US,
};

export const defaultLanguageCountry = 'en_US';

const countries = {
  de_DE: 'DEU',
  en_US: 'USA',
};

const languages = {
  de_DE: 'de',
  en_US: 'en',
};

export const languageOptionList = {
  de_DE: 'de_DE',
  en_US: 'en_US',
};

const baseUrls = {
  dev: 'https://api.digital-help-dev.autodesk.com',
  int: 'https://api.digital-help-int.autodesk.com',
  stg: 'https://api.digital-help-stg.autodesk.com',
  prd: 'https://api.digital-help-prd.autodesk.com',
};

const apiUrls = {
  dev: baseUrls.dev + '/services/v1',
  int: baseUrls.int + '/services/v1',
  stg: baseUrls.stg + '/services/v1',
  prd: baseUrls.prd + '/services/v1',
};

const jsonUrls = {
  dev: baseUrls.dev + '/static',
  int: baseUrls.int + '/static',
  stg: baseUrls.stg + '/static',
  prd: baseUrls.prd + '/static',
};

/**
 * Gets the value stored in a map.
 *
 * @param { map } obj map
 * @param { string } key for map
 *
 * @returns { string } value
 */
function getMapValue(obj, key) {
  // eslint-disable-next-line no-prototype-builtins
  if (obj.hasOwnProperty(key)) {
    return obj[key];
  }
  throw new Error('Invalid map key');
}

/**
 * Gets the country based on the key.
 *
 * @param { string } key country
 * @returns { string } value country
 */
export function getCountry(key) {
  return getMapValue(countries, key);
}

/**
 * Gets the language based on the key.
 *
 * @param { string } key language
 * @returns { string } value language
 */
export function getLanguage(key) {
  return getMapValue(languages, key);
}

/**
 * Gets the apiUrl based on the key.
 *
 * @param { string } key country
 * @returns { string } value country
 */
export function getApiUrl(key) {
  return getMapValue(apiUrls, key);
}

/**
 * Gets the apiUrl based on the key.
 *
 * @param { string } key country
 * @returns { string } value country
 */
export function getJsonUrl(key) {
  return getMapValue(jsonUrls, key);
}
